import { render } from "./clinicVerify.vue?vue&type=template&id=211d212e&scoped=true"
import script from "./clinicVerify.vue?vue&type=script&lang=js"
export * from "./clinicVerify.vue?vue&type=script&lang=js"

import "./clinicVerify.vue?vue&type=style&index=0&id=211d212e&lang=scss&scoped=true"

import exportComponent from "/home/hsf/.jenkins/workspace/mmm-overseas-prod-hongkong/rith-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211d212e"]])

export default __exports__